import { FeatureCode } from 'generated/graphql';

export type Features =
  | Array<{
      id: number;
      code: FeatureCode;
      name: string;
    } | null>
  | null
  | undefined;

export const getLivestreamingEnabled = (features: Features) =>
  (features || []).some((f) => f?.code === FeatureCode.Livestream);
export const getDmEnabled = (features: Features) =>
  (features || []).some((f) => f?.code === FeatureCode.Dm);
export const getCommunityEnabled = (features: Features): boolean =>
  (features || []).some((f) => f?.code === FeatureCode.Community);
